import createModel, { prop } from './lib/create_model';

const AutoTranslation = createModel({
  modelName: 'AutoTranslation',

  properties: {
    targetLanguage: prop(String).isRequired,
  },

  statics: {
    create(attrs = {}) {
      return new AutoTranslation(attrs);
    },
  },
});

export default AutoTranslation;
